import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EBracketTypes } from "../../../shared/enums/utility.enums";
import { ClickEvent } from "../../../shared/types/event.types";
import { RootState } from "../../../state-management/root-reducer";
import { setPinBracketType } from "../../../state-management/slices/global/global.slice";
import STREETLIGHT_ICON from "../../icon/streetlight-icon/StreetlightIcon.component";
import BracketTypeStyles from "./BracketTypeSelector.styles";
import { IBracketTypeSelectorProps } from "./BracketTypeSelector.types";
import BracketTypeSelectorUtils from "./BracketTypeSelector.utils";

const BRACKET_TYPE_SELECTOR: React.FC<IBracketTypeSelectorProps> = (props) => {
  const { globalState } = useSelector((state: RootState) => state);
  const [selectedIconId, setSelectedIcon] = useState("");
  const dispatch = useDispatch();

  const { onChange } = props;

  useEffect(() => {
    let selectedBracketType = null;
    if (globalState && globalState.ui) {
      const { pinMode } = globalState?.ui;
      if (pinMode) {
        // eslint-disable-next-line prefer-destructuring
        selectedBracketType = pinMode.selectedBracketType;
      }
    }

    if (selectedBracketType && selectedIconId !== selectedBracketType) {
      if (selectedBracketType) {
        setSelectedIcon(selectedBracketType);
      }
    }
  }, [globalState, selectedIconId]);

  return (
    <BracketTypeStyles.BracketTypeSelector
      className="bracket-type-selector"
      title="Select a light type"
      onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const { parentElement } = event.target as HTMLDivElement;
        if (parentElement) {
          onChange({
            previousValue: selectedIconId,
            newValue: parentElement.id,
          });
          dispatch(
            setPinBracketType({
              bracketType: parentElement.id as EBracketTypes,
            })
          );
        }
      }}
    >
      <STREETLIGHT_ICON
        type={EBracketTypes.COBRA}
        reported={0}
        bgFill={BracketTypeSelectorUtils.getFillColor(
          EBracketTypes.COBRA,
          selectedIconId
        )}
      />
      <STREETLIGHT_ICON
        type={EBracketTypes.POST_TOP}
        reported={0}
        bgFill={BracketTypeSelectorUtils.getFillColor(
          EBracketTypes.POST_TOP,
          selectedIconId
        )}
      />
      <STREETLIGHT_ICON
        type={EBracketTypes.CENTER_SUSPENSION}
        reported={0}
        bgFill={BracketTypeSelectorUtils.getFillColor(
          EBracketTypes.CENTER_SUSPENSION,
          selectedIconId
        )}
      />
    </BracketTypeStyles.BracketTypeSelector>
  );
};

export default BRACKET_TYPE_SELECTOR;
